/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-indent */
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { seelectEntidad } from 'store/auth';
import { selectBloqueosCalendario } from 'store/app';
import { bloqueosDeRuta } from 'utils/bloqueoCalendario';
import { buildTableFiltersKey, TABLE_FILTERS_SYNC_EVENT } from 'utils/tableFiltersStorage';
import {
  Table as AntTable,
  Row,
  Col,
  Button,
  Input,
  Dropdown,
  Popover,
  Select,
  Typography,
  Grid,
  Form,
  Modal,
  Spin,
  Progress,
  Tooltip,
  message,
  notification,
} from 'antd';
import {

  UndoOutlined,
  CheckOutlined,
  ReloadOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  SearchOutlined,
  CloseOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SettingOutlined,
  TableOutlined,
  ArrowLeftOutlined,
  ExpandOutlined,
  DownOutlined,
  RightOutlined,
  UploadOutlined,
  MinusCircleOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  PrinterOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { FaClipboardList } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import HTTP, { baseURL } from 'utils/api';
import { docHeight } from 'utils/responsive';
import { onError } from 'utils/handlers';
import { hasActionPermission } from 'utils/permission';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import Pagination from 'components/Pagination';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import descargarPDFGeneral from './PDF/descargarPDFGeneral';

const { Option } = Select;
const { Text } = Typography;

// Definido a nivel de módulo (no dentro de <Table>): declarado dentro del render, cada
// re-render de <Table> creaba un tipo de componente nuevo y React desmontaba/remontaba el
// botón. Si ese re-render caía entre el mousedown y el mouseup, el navegador nunca
// disparaba 'click' (el nodo donde se soltó el mouse ya no era el mismo) y el botón "no
// hacía nada" -- mientras el doble clic sobre la fila sí funcionaba, porque las filas no se
// remontan. Por la misma razón TableControls se invoca como función, no como <TableControls />.
const ButtonWrapper = ({
  children,
  hasPermission,
  hasAllViewPermission,
  hasSelection,
  edit,
  delete: _delete,
}) => {
  if (hasPermission && hasAllViewPermission) {
    const needKey = edit || _delete;
    if ((needKey && hasSelection) || !needKey) {
      return children;
    }
    return (
      <Tooltip title="Seleccione un elemento para realizar esta acción">
        {children}
      </Tooltip>
    );
  }

  return (
    <Tooltip title="No tienes los permisos necesarios para realizar esta acción">
      {children}
    </Tooltip>
  );
};

ButtonWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  hasPermission: PropTypes.bool,
  hasAllViewPermission: PropTypes.bool,
  hasSelection: PropTypes.bool,
  edit: PropTypes.bool,
  delete: PropTypes.bool,
};

ButtonWrapper.defaultProps = {
  hasPermission: false,
  hasAllViewPermission: false,
  hasSelection: false,
  edit: false,
  delete: false,
};

/**
 * Extrae el texto plano de un valor renderizado de columna (string, número,
 * array de nodos, o elemento de React con `props.children` anidado -
 * ej. un <div> que envuelve varios <Tag>) para poder buscarlo/filtrarlo como
 * texto. Evita el crash `valueRender.toLowerCase is not a function` cuando
 * `props.children` no es directamente un string (columnas con contenido
 * compuesto, como "Firmantes" en Nombramientos).
 */
const extractTextFromNode = (node) => {
  if (node === null || node === undefined) return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractTextFromNode).join(' ');
  if (node?.props?.children !== undefined) return extractTextFromNode(node.props.children);
  return '';
};

const Table = ({
  cols,
  mobileCols: _mobileCols,
  data,
  customDataArbolado,
  titleTable,
  rowSelection,
  onRow: _onRow,
  editText,
  secondaryEditText,
  addText,
  deleteText,
  unasignText,
  noControls,
  controls,
  reportsMenu,
  customExportMenu,
  customImportMenu,
  customImportMenuExtra,
  customImportMenuExtraPago,
  allowCustomExport,
  allowCustomImport,
  allowCustomImportExtra,
  allowCustomImportExtraPago,
  customImportText,
  customImportExtraText,
  customImportExtraTextPago,
  allowEdit,
  allowAdd,
  allowDelete,
  allowUnasign,
  allowSearch,
  defaultSearchVisible,
  allowSort,
  allowImport,
  allowExtraImport,
  allowExtraImportPago,
  allowConfig,
  allowExpand,
  allowExportParam,
  allowActivate,
  allowDeactivate,
  allowMultiTrueChanger,
  allowMultiFalseChanger,
  multiTrueChangerText,
  multiFalseChangerText,
  allowDoubleClick,
  allowReports,
  allowReload,
  disableAdd,
  disableEdit,
  disableSecondaryEdit,
  disableDelete,
  disableActivate,
  disableDeactivate,
  allowReprint,
  expandable: _expandable,
  filterNested,
  childrenProp,
  RTLHead,
  rowKey,
  fillHeight,
  autoFit,
  customActions,
  customActionsDropdown,
  customActionsDropdownText,
  groupImports,
  groupImportsText,
  handleOnRowClick,
  // eslint-disable-next-line no-unused-vars
  mobileColIndex,
  pageSize,
  disabled,
  allowColumnSelector,
  baseURI,
  baseURIExtra,
  baseURIExtraPago,
  asyncImport,
  asyncImportExtra,
  asyncImportExtraPago,
  labelExtraImport,
  labelExtraImportPago,
  indentSize,
  loading: tableLoading,
  justImport,
  allowedExtensions,
  permission,
  hasAllViewPermission: _hasAllViewPermission,
  pagination,
  paginationCallback,
  count,
  currentPage,
  summaryCells,
  allowExportExcel,
  allowExportPDF,
  allowExtractData,
  setExtractData,
  allowMultiSelect,
  allowMultiDeselect,
  onMultiSelect,
  onMultiDeselect,
  onExportExcel,
  extraExportItems,
  onTableChange,
  persistFilters,
  storageId,
}) => {
  cols = cols.filter((e) => e.disable !== true);
  // eslint-disable-next-line no-param-reassign
  rowKey = rowKey || (_expandable || childrenProp || filterNested ? 'key' : 'id');
  childrenProp = filterNested ? 'children' : null;
  const screens = Grid.useBreakpoint();
  const location = useLocation();
  // Calendario de Nóminas: si la funcionalidad de esta pantalla está cerrada hoy, se
  // deshabilitan Agregar/Eliminar/Importar. Editar se deja para poder consultar el registro;
  // si se intenta guardar, el backend rechaza el cambio con el motivo del cierre.
  const bloqueosCalendario = useSelector(selectBloqueosCalendario);
  if (bloqueosDeRuta(bloqueosCalendario, location.pathname).length) {
    // eslint-disable-next-line no-param-reassign
    permission = { ...permission, add: false, delete: false };
  }
  // Identifica esta tabla dentro de la ruta actual para no mezclar filtros de tablas distintas
  // que compartan la misma pantalla. No basta con permission.model: varias tablas de una misma
  // vista (p. ej. tabla principal + historial SBC + direcciones) comparten el mismo modelo de
  // permisos, así que se agrega una firma de columnas para diferenciarlas entre sí.
  // Con `storageId` explícito la clave no depende de las columnas (ver buildTableFiltersKey).
  const filterStorageKey = buildTableFiltersKey(location.pathname, {
    storageId,
    // eslint-disable-next-line react/prop-types
    model: permission?.model,
    cols,
  });

  const readStoredFilters = () => {
    if (!persistFilters) return null;
    try {
      const raw = sessionStorage.getItem(filterStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  };
  const mobileCols = _mobileCols.length ? _mobileCols : [cols[0]];
  const [open, setVisible] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalExtra, setVisibleModalExtra] = useState(false);
  const [visibleModalExtraPago, setVisibleModalExtraPago] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  // Alto de fila -- arranca en 40 (fila de una sola línea) y se corrige en cuanto hay
  // filas reales pintadas (ver measureTableHeight): columnas con texto largo (p. ej.
  // "Puesto"/"Área" en Registro de Vacaciones) envuelven a 2-3 líneas y una fila real
  // termina midiendo 60-100px, no 40 -- con el valor fijo, calcPageSize metía más filas
  // por página de las que en realidad caben en tableHeight, forzando scroll interno de
  // la tabla (o de la página) para llegar a ver la paginación.
  const ROW_HEIGHT_FALLBACK = 40;
  const [rowHeight, setRowHeight] = useState(ROW_HEIGHT_FALLBACK);
  // Alto medido de cada fila ya pintada, por `data-row-key`, acumulado entre páginas (ver
  // measureTableHeight). Se vacía al cambiar los datos o el ancho del contenedor (el
  // ancho/zoom cambia cuántas líneas envuelve cada fila).
  const rowHeightsCacheRef = useRef(new Map());
  const lastMeasuredWidthRef = useRef(0);
  // Antes tenía un piso de 10 filas por página sin importar el espacio real disponible
  // -- en contenedores más bajos (laptops, ventanas chicas) eso obligaba a mostrar 10
  // filas aunque solo cupieran 4 o 5, con el mismo efecto de scroll no deseado. El piso
  // de 3 solo evita el caso extremo de una página con 1-2 filas por un cálculo erróneo.
  const calcPageSize = (h) => Math.max(3, Math.floor(h / rowHeight));
  const [tableHeight, setTableheight] = useState(window.innerHeight - 366);
  // Con fillHeight se redondea hacia arriba (ver comentario del wrapper más abajo).
  const autoPageSize = fillHeight
    ? Math.max(3, Math.ceil(tableHeight / rowHeight))
    : calcPageSize(tableHeight);
  const tableWrapperRef = useRef(null);
  // Nodo actual del wrapper en estado (además del ref) para que los ResizeObserver se
  // vuelvan a enganchar cada vez que el wrapper se monta de nuevo: el Fragment cambia de
  // `key` justo después del primer render, y el wrapper solo existe en el render de
  // escritorio, así que puede no existir (o ser otro nodo) cuando corre el efecto inicial.
  const [wrapperNode, setWrapperNode] = useState(null);
  const setTableWrapperRef = useCallback((node) => {
    tableWrapperRef.current = node;
    setWrapperNode(node);
  }, []);
  const [visibleWidth, setVisibleWidth] = useState(0);
  const [lastDataSource, setLastDataSource] = useState([]);
  const [focusedInput, setFocusedInput] = useState();
  const [filters, setFilters] = useState(() => {
    const stored = readStoredFilters();
    return cols.map((col) => ({
      prop: col.dataIndex,
      value: stored?.find((f) => f.prop === col.dataIndex)?.value ?? null,
    }));
  });
  const [scrollX, setScrollX] = useState(0);
  const [visibleSarch, setVisibleSearch] = useState(() => defaultSearchVisible
    || !!readStoredFilters()?.some((f) => f.value));
  const [componentKey, setComponentKey] = useState();
  // Identifica esta instancia para ignorar sus propios avisos de sincronización de filtros.
  const instanceIdRef = useRef(`${Date.now()}-${Math.random()}`);
  const allowedCustomActions = customActions.filter(({ permission: _permission }) => !_permission
    || hasActionPermission(_permission?.model, _permission?.action));

  // normalize/validate params
  allowExpand = allowExpand && !!controls?.onClickExpand;
  allowAdd = allowAdd && !!controls?.onClickAdd;
  allowReload = allowReload && !!controls?.onClickReload;
  allowEdit = allowEdit && !!controls?.onClickEdit;
  allowDelete = allowDelete && !!controls?.onClickDelete;
  allowUnasign = allowUnasign && !!controls?.onClickUnasign;
  allowImport = allowImport && baseURI;
  allowExtraImport = allowExtraImport && baseURIExtra;
  allowExtraImportPago = allowExtraImportPago && baseURIExtraPago;
  const allowExport = allowExportParam; // baseURI && (permission?.export || !permission);
  const ref = useRef();
  const [page, setPage] = useState(1);
  // Arma la consulta que se envía al servidor (tablas paginadas en servidor) a partir de los
  // filtros capturados, porque el valor que teclea el usuario es el texto que ve en el grid y
  // no siempre es lo que el backend acepta:
  // - Importes: "$12,000.00" -> "12000.00" (si no, el NumberFilter responde 400).
  // - Columnas cuyo campo es un id pero muestran un texto: la columna puede definir
  //   `searchKey` con el nombre del filtro de texto del backend.
  // - Valores que el backend rechazaría (fecha a medio capturar, texto en columna numérica)
  //   marcan `incompleta` para no consultar todavía y evitar la advertencia de error.
  function construirConsultaServidor(lista = []) {
    const columnas = (cols || []).flatMap((c) => (c.children ? c.children : [c]));
    const valoresDe = (campo) => (data || []).map((row) => row?.[campo])
      .filter((v) => v !== null && v !== undefined && v !== '');
    // Fecha si viene en ISO o ya convertida a moment/Date, o si el campo se llama fecha_*.
    const esColumnaFecha = (campo) => /^fecha/.test(String(campo)) || valoresDe(campo).some((v) => (
      // eslint-disable-next-line no-underscore-dangle
      !!v?._isAMomentObject || v instanceof Date
      || (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v))
    ));
    // Numérica si todos sus valores en la página son números (o texto numérico, como los
    // DecimalField que el API manda como "547.20").
    const esColumnaNumerica = (campo) => {
      const valores = valoresDe(campo);
      return valores.length > 0 && valores.every((v) => typeof v === 'number'
        || (typeof v === 'string' && /^-?\d+(\.\d+)?$/.test(v.trim())));
    };
    let incompleta = false;
    const consulta = {};
    lista.forEach(({ prop, value }) => {
      const columna = columnas.find((c) => c.dataIndex === prop);
      const clave = columna?.searchKey || prop;
      let valor = value;
      if (typeof valor === 'string' && valor.trim()) {
        let texto = valor.trim();
        const fechaCompleta = /^\d{2}\/\d{2}\/\d{4}$/.test(texto);
        if (!fechaCompleta && ((texto.includes('/') && /^[\d/]+$/.test(texto))
          || (esColumnaFecha(prop) && /^[\d/-]+$/.test(texto)))) {
          incompleta = true;
        }
        if (/^-?\$?\s*-?[\d,]+(\.\d*)?$/.test(texto) && /[$,]/.test(texto)) {
          texto = texto.replace(/[$,\s]/g, '');
        }
        if (!columna?.searchKey && esColumnaNumerica(prop) && !esColumnaFecha(prop)
          && !/^-?\d+(\.\d*)?$/.test(texto)) {
          incompleta = true;
        }
        valor = texto;
      }
      consulta[clave] = valor;
    });
    return { consulta, incompleta };
  }

  // Guarda la consulta ya normalizada para que las vistas la reutilicen al pedir los datos de
  // otro tab (readPersistedTableQuery lee esta clave).
  const guardarConsultaServidor = (consulta) => {
    if (!persistFilters) return;
    try {
      sessionStorage.setItem(`${filterStorageKey}:consulta`, JSON.stringify(consulta || {}));
    } catch (err) {
      // ignora errores de almacenamiento (cuota excedida, modo privado, etc.)
    }
  };

  // Consulta de búsqueda para tablas paginadas en servidor; arranca con la búsqueda guardada
  // (p. ej. la que se capturó en otro tab) para que la paginación la respete.
  const [q, setQ] = useState(() => {
    const stored = readStoredFilters();
    return stored?.some((f) => f.value)
      ? construirConsultaServidor(stored).consulta
      : undefined;
  });
  const entidad = useSelector(seelectEntidad);

  let expandable = null;

  if (!_expandable && childrenProp) {
    expandable = {
      expandRowByClick: true,
      childrenColumnName: childrenProp,
      indentSize,
      expandIcon: ({ expanded, onExpand, record }) => (record[childrenProp] && (
        expanded ? (
          <DownOutlined onClick={(e) => onExpand(record, e)} />
        ) : (
          <RightOutlined onClick={(e) => onExpand(record, e)} />
        )
      )),
    };
  }

  const onRow = _onRow || ((record) => ({
    onClick: () => {
      if (_expandable && !_expandable.expandRowByClick) {
        _expandable.expandRowByClick = true;
      }
      if (handleOnRowClick) {
        handleOnRowClick(record);
      }
    },
    onDoubleClick: () => {
      if (controls?.onClickExpand && allowDoubleClick) {
        controls.onClickExpand(record);
      } else if (controls?.onClickEdit && rowSelection?.selectedRowKeys.length < 2
        && permission?.change && allowDoubleClick) {
        controls.onClickEdit(record);
      } else if (controls?.onClickConfig && permission?.change && allowDoubleClick) {
        controls.onClickConfig();
      } else if (controls?.onClickDeactivate && permission.change && allowDoubleClick) {
        controls.onClickDeactivate();
      }
    },
  }));

  const SortControls = (prop, onAscend, onDescend) => (
    <Col id={`sort-controls-${prop}`}>
      <CaretUpOutlined onClick={onAscend} />
      <CaretDownOutlined onClick={onDescend} />
    </Col>
  );

  const highlight = (prop, ascend = false) => {
    const controlsCont = document.getElementById(`sort-controls-${prop}`);
    const up = controlsCont.querySelector('.anticon-caret-up');
    const down = controlsCont.querySelector('.anticon-caret-down');
    // Clear all active styles
    const all = document.querySelectorAll('.anticon-caret-up, .anticon-caret-down');
    all.forEach((element) => {
      element.classList.remove('active');
    });
    // Set active style
    if (ascend) {
      up.classList.add('active');
    } else {
      down.classList.add('active');
    }
  };

  // Función para obtener el valor a comparar de una columna
  const getCellValue = (rowData, prop, column) => {
    if (!column || !column.render) {
      return rowData[prop]; // si no tiene render
    }
    const valorCelda = column.render(rowData[prop], rowData);
    if (valorCelda?.props) {
      const valorCeldaProps = valorCelda?.props;
      return valorCeldaProps?.children; // si el render tiene props o etiqueta con diseño
    }
    return valorCelda;
  };

  const compareValues = (a, b, prop, column, ascend) => {
    const aValue = getCellValue(a, prop, column);
    const bValue = getCellValue(b, prop, column);

    if (!aValue && !bValue) return 0; // Si ambos son vacios
    if (!aValue) return ascend && 1; // Si aValue es vacio se coloca al final
    if (!bValue) return ascend && -1; // Si bValue es vacio se coloca al final

    const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const currencyPattern = /^\$([0-9,]+(\.[0-9]{2})?)$/;

    if (datePattern.test(aValue) && datePattern.test(bValue)) {
      // Toma la cadena correspondiente a la fecha que obtuvo del render (DD/MM/YYYY)
      // y la cambia al formato YYYY-MM-DD para transformarla en un objeto Date
      const dateA = new Date(aValue.replace(datePattern, '$3-$2-$1'));
      const dateB = new Date(bValue.replace(datePattern, '$3-$2-$1'));
      return ascend ? dateA - dateB : dateB - dateA;
    }

    if (currencyPattern.test(aValue) && currencyPattern.test(bValue)) {
      // Toma la cadena correspondiente al valor que obtuvo con formato de moneda
      // elimina los caracteres no numéricos y lo parsea a float
      const numericA = parseFloat(aValue.replace(/[\$,]/g, ''));
      const numericB = parseFloat(bValue.replace(/[\$,]/g, ''));
      return ascend ? numericA - numericB : numericB - numericA;
    }
    // Si el valor no es una fecha o un valor de moneda entonces se toma el string
    return ascend
      ? aValue?.toString().localeCompare(bValue?.toString(), 'es', { numeric: true })
      : bValue?.toString().localeCompare(aValue?.toString(), 'es', { numeric: true });
  };

  // ordenada una columna por Asc y Desc
  const sortData = (prop, ascend = true) => {
    const dataClone = [...dataSource];
    const column = columns.find((col) => col.dataIndex === prop);
    const sortedData = dataClone.sort((a, b) => compareValues(a, b, prop, column, ascend));
    setDataSource(sortedData);
    highlight(prop, ascend);
  };

  let filtNested = [];

  const filterNestedData = () => {
    const allValuesAreFalsy = filters.every((item) => !item.value);
    if (allValuesAreFalsy) {
      filtNested = [];
    } else {
      filtNested = customDataArbolado;
    }
  };

  useEffect(() => {
    if (focusedInput && (!dataSource.length || (!lastDataSource.length && dataSource.length))) {
      const input = document.getElementById(focusedInput);
      setTimeout(() => {
        input.focus();
      });
    }
    // eslint-disable-next-line
  }, [dataSource]);

  useEffect(() => {
    if (filterNested) {
      filterNestedData();
      filterData();
    } else {
      filterData();
    }
    if (persistFilters) {
      try {
        sessionStorage.setItem(filterStorageKey, JSON.stringify(filters));
      } catch (err) {
        // ignora errores de almacenamiento (cuota excedida, modo privado, etc.)
      }
    }
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    if (page !== currentPage) {
      setPage(currentPage);
    }
    // eslint-disable-next-line
  }, [currentPage]);

  // Recibe la búsqueda capturada en otro <Table> con la misma clave de filtros (otro tab de
  // la misma pantalla) y la aplica aquí, para no tener que volver a buscar en cada tab. Solo
  // En las tablas paginadas en servidor (paginationCallback sin pagination) solo se actualiza la
  // búsqueda y la consulta `q`, sin pedir datos: cada tab oculto haría su propia petición. La
  // vista incluye la búsqueda guardada al pedir los datos del tab (readPersistedTableQuery).
  useEffect(() => {
    if (!persistFilters) return undefined;
    const onFiltersSync = (event) => {
      const { key, filters: incoming, source } = event.detail || {};
      if (key !== filterStorageKey || source === instanceIdRef.current) return;
      setFilters(cols.map((col) => ({
        prop: col.dataIndex,
        value: incoming?.find((f) => f.prop === col.dataIndex)?.value ?? null,
      })));
      if (incoming?.some((f) => f.value)) setVisibleSearch(true);
      if (paginationCallback && !pagination) {
        setQ(construirConsultaServidor(incoming || []).consulta);
        setPage(1);
      }
    };
    window.addEventListener(TABLE_FILTERS_SYNC_EVENT, onFiltersSync);
    return () => window.removeEventListener(TABLE_FILTERS_SYNC_EVENT, onFiltersSync);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterStorageKey, persistFilters]);

  const setFilter = (prop, value) => {
    let filtersClone = [...filters];
    filtersClone = filtersClone.filter((elem) => elem.prop !== prop);
    filtersClone.push({ prop, value });
    setFilters(filtersClone);
    if (persistFilters) {
      window.dispatchEvent(new CustomEvent(TABLE_FILTERS_SYNC_EVENT, {
        detail: { key: filterStorageKey, filters: filtersClone, source: instanceIdRef.current },
      }));
    }
    if (paginationCallback && !pagination) {
      clearTimeout(ref.current);
      const { consulta: _q, incompleta } = construirConsultaServidor(filtersClone);
      setQ(_q);
      // Una fecha a medio capturar (p. ej. "11/05") o texto en una columna numérica haría que
      // el backend respondiera 400 y se mostrara la advertencia mientras el usuario escribe:
      // se espera a que el valor sea válido antes de consultar al servidor.
      // Siempre desde la página 1 (antes usaba la página actual, que con la búsqueda nueva
      // puede no existir) y con una espera corta para que no parezca que no encontró nada.
      if (!incompleta) {
        guardarConsultaServidor(_q);
        ref.current = setTimeout(() => paginationCallback(1, _q), 700);
      }
      setPage(1);
    }
  };

  let timeoutSearch;

  const getTitle = (title, prop) => {
    const Icon = () => (filters.find((a) => a.prop === prop)?.value
      ? <CloseOutlined onClick={() => setFilter(prop, null)} /> : <SearchOutlined />);
    return (
      <>
        <Row>
          <span className={RTLHead ? 'head headRight' : 'head'}>
            {title}
          </span>
          {allowSort ? SortControls(
            prop,
            () => sortData(prop),
            () => sortData(prop, false),
          ) : ''}
        </Row>
        {(allowSearch && visibleSarch) && (
          <Row>
            <Input
              id={`input-${prop}`}
              placeholder=""
              value={filters.find((a) => a.prop === prop)?.value || ''}
              onChange={(e) => {
                const value = e?.target?.value;
                if (timeoutSearch) {
                  clearTimeout(timeoutSearch);
                }
                timeoutSearch = setTimeout(() => {
                  setFilter(prop, value);
                });
              }}
              onFocus={() => setFocusedInput(`input-${prop}`)}
            />
            <Icon />
          </Row>
        )}
      </>
    );
  };

  // El wrapper solo existe en el render de escritorio (ver `<div ref={tableWrapperRef}>`
  // más abajo); en el render móvil no hay wrapper y se mantiene el cálculo previo.
  const measureTableHeight = () => {
    // Opt-out (`autoFit={false}`): tamaño normal, sin medir el contenedor ni ajustar filas por
    // página según el espacio disponible. Alto de la tabla fijo al cálculo base por ventana y
    // pageSize fijo (ver `pagination` más abajo). Pensado para pantallas donde el ajuste
    // automático oscila (p. ej. Evaluación de Reloj Checador); por defecto sigue activo.
    if (!autoFit) {
      setTableheight(window.innerHeight - 366);
      return;
    }
    const wrapper = tableWrapperRef.current;
    const scrollBoundary = wrapper
      ? wrapper.closest('.ant-card-body, .ant-tabs-content-holder, .customCard') || document.body
      : null;
    if (!wrapper || !scrollBoundary) {
      setTableheight(window.innerHeight - 366);
      return;
    }
    // Se mide el alto real disponible contra el contenedor con scroll más cercano
    // (`.ant-card-body` de un Card, `.ant-tabs-content-holder` de un Tabs sin Card
    // alrededor, o `.customCard` del layout si no hay ninguno de los dos) en vez de restar
    // un offset fijo a window.innerHeight. Así la tabla ocupa exactamente el espacio que
    // le queda sin importar cuántas capas de breadcrumb/card-head/tabs haya arriba, y ese
    // contenedor ambiente deja de necesitar su propio scroll (scroll duplicado entre el
    // layout y la tabla).
    const wrapperTop = wrapper.getBoundingClientRect().top;
    const boundaryBottom = scrollBoundary.getBoundingClientRect().bottom;
    // El encabezado se mide directo del DOM en vez de asumir un alto fijo: con columnas
    // agrupadas (ej. "Candidatos / Becarios" con sub-columnas) el thead tiene una fila
    // extra y es más alto de lo normal — un número fijo se queda corto ahí y la tabla
    // termina un poco más alta de lo que cabe, haciendo que el contenedor ambiente
    // (`.ant-tabs-content-holder`/`.ant-card-body`/`.customCard`) también scrollee.
    const theadHeight = wrapper.querySelector('.ant-table-thead')?.getBoundingClientRect().height || 55;
    // paginación + paddings + margen visual inferior (para que la tabla no quede pegada al
    // borde inferior de la tarjeta/customCard)
    const tableChromeHeight = theadHeight + 80;
    const available = boundaryBottom - wrapperTop - tableChromeHeight;
    setTableheight(Math.max(available, 150));

    // Corrige rowHeight con el alto real ya pintado (ver comentario donde se declara
    // rowHeight) usando el PROMEDIO de las filas visibles. Antes se tomaba la fila más
    // alta, pero bastaba una sola fila con texto envuelto a 4 líneas (p. ej. un Puesto
    // largo en Empleados, ~105px contra ~60px del resto) para que calcPageSize dividiera
    // todo el alto disponible entre ese máximo: la tabla mostraba 5 filas y dejaba vacía
    // media pantalla (y en 4K, tres cuartas partes). Con el promedio la página llena el
    // espacio real; si una página en particular trae más filas largas que el promedio,
    // el excedente queda contenido en el scroll interno de la tabla (`scroll.y`), no en
    // el de la página. Solo se actualiza si cambia lo suficiente (>4px) para no disparar
    // un re-render por cada medición casi idéntica.
    //
    // El promedio se calcula sobre TODAS las filas medidas hasta ahora (caché por
    // `data-row-key`), no solo sobre la página visible: con solo la página visible se
    // formaba un ciclo -- una página con filas envueltas subía rowHeight -> bajaba
    // pageSize -> cambiaba el número de páginas y la página actual pasaba a tener otras
    // filas (p. ej. una sola fila corta) -> bajaba rowHeight -> subía pageSize -> ... y la
    // paginación parpadeaba sin fin (visto en Configuración de Solicitudes de Percepción
    // al hacer zoom). Como la caché solo crece, el promedio converge.
    const renderedRows = wrapper.querySelectorAll('.ant-table-tbody > tr.ant-table-row');
    if (renderedRows.length) {
      const cache = rowHeightsCacheRef.current;
      Array.from(renderedRows).forEach((r, idx) => {
        const h = r.getBoundingClientRect().height;
        if (h > 0) cache.set(r.getAttribute('data-row-key') ?? `__idx_${idx}`, h);
      });
      const heights = Array.from(cache.values());
      const avgRowHeight = heights.length
        ? heights.reduce((sum, h) => sum + h, 0) / heights.length
        : 0;
      if (avgRowHeight > 0) {
        setRowHeight((prev) => (Math.abs(avgRowHeight - prev) > 4 ? avgRowHeight : prev));
      }
    }
  };

  useEffect(() => {
    measureTableHeight();
    const key = new Date().getTime();
    setComponentKey(`${key}_table`);
    window.addEventListener('resize', measureTableHeight);
    return () => {
      window.removeEventListener('resize', measureTableHeight);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Se engancha al contenedor ambiente del wrapper ACTUAL (ver `wrapperNode`) y mide
    // en cuanto el wrapper existe, en vez de solo en el primer montaje.
    if (!wrapperNode) return undefined;
    measureTableHeight();
    const scrollBoundary = wrapperNode.closest('.ant-card-body, .ant-tabs-content-holder, .customCard')
      || document.body;
    const boundaryObserver = new ResizeObserver(measureTableHeight);
    boundaryObserver.observe(scrollBoundary);
    return () => boundaryObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperNode]);

  useEffect(() => {
    // Vuelve a medir cuando cambian los datos: por ejemplo, cuando la vista que consume
    // <Table> muestra un banner ("Datos cargados en X segundos...") justo arriba de la
    // tabla apenas termina de cargar (ver Empleados.jsx). Ese acomodo no dispara 'resize'
    // ni el ResizeObserver del contenedor ambiente (su tamaño no cambia, solo se
    // reacomoda su contenido), así que sin este efecto la tabla se queda con el alto
    // medido en el primer render, antes de que ese banner empujara el wrapper hacia abajo.
    //
    // OJO: depende de `dataSource` (el state que de verdad pinta <AntTable>), no de
    // `data` (la prop cruda). `dataSource` se actualiza en el efecto de filterData()
    // sobre `[data]`, un efecto SEPARADO -- si este efecto dependiera de `data`, corre
    // en el mismo commit pero antes de que `dataSource` (y por lo tanto las filas
    // reales en el DOM) exista, así que la medición de rowHeight de measureTableHeight
    // siempre encontraría cero filas y nunca corregiría el estimado de 40px.
    rowHeightsCacheRef.current.clear();
    measureTableHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource]);

  useEffect(() => {
    if (!wrapperNode) return undefined;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect?.width;
      if (width) {
        if (Math.abs(lastMeasuredWidthRef.current - width) > 1) {
          rowHeightsCacheRef.current.clear();
          lastMeasuredWidthRef.current = width;
        }
        setVisibleWidth(width);
        // Una tabla dentro de un tab inactivo se monta oculta (ancho 0) y mide un alto
        // incorrecto; al mostrarse su ancho cambia y aquí se vuelve a medir contra el
        // espacio real disponible, para que la paginación no quede fuera de la vista.
        measureTableHeight();
      }
    });
    observer.observe(wrapperNode);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperNode]);

  useEffect(() => {
    if (filterNested) {
      filterNestedData();
      filterData();
    } else {
      filterData();
    }
    // eslint-disable-next-line
  }, [data]);

  const mobileColumns = mobileCols?.length > 1
    ? mobileCols.map((c) => ({
      ...c, key: c.dataIndex, title: c.titleText, width: c.width,
    }))
    : mobileCols.map((c) => ({
      ...c, key: c.dataIndex, title: c.titleText, width: '100%',
    }));

  const [selectedCols, setSelectedCols] = useState(cols.map(({ dataIndex }) => dataIndex));

  // Las columnas que la vista agrega después del primer render (p. ej. las que dependen de un
  // catálogo que termina de cargar) se muestran; las que el usuario ocultó se respetan.
  const colsKeys = cols.map(({ dataIndex }) => dataIndex);
  const knownColsRef = useRef(colsKeys);
  useEffect(() => {
    const nuevas = colsKeys.filter((key) => !knownColsRef.current.includes(key));
    knownColsRef.current = colsKeys;
    if (nuevas.length) {
      setSelectedCols((prev) => [...prev, ...nuevas]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colsKeys.join('|')]);

  const columns = cols.map((col) => {
    if (col.children) {
      return {
        ...col,
        title: col.titleText,
        children: col.children.map((child) => ({
          ...child,
          title: getTitle(child.titleText || child.title, child.key?.trim() || child.dataIndex),
        })),
      };
    }
    return {
      ...col,
      key: col.dataIndex,
      title: getTitle(col.titleText, col.key?.trim() || col.dataIndex),
    };
  });

  const filterData = () => {
    setLastDataSource(dataSource);
    // const dataClone = filtNested.length ? [...filtNested] : [...data];
    let dataClone = [];
    if (Array.isArray(filtNested) && filtNested.length > 0) {
      dataClone = [...filtNested];
    } else if (Array.isArray(data)) {
      dataClone = [...data];
    }

    let filtered = dataClone;
    const filterList = filters.filter((item) => !!item.value);
    if (filterList.length) {
      filterList.forEach(({ prop, value }) => {
        filtered = filtered.filter((item) => {
          const flatColumns = columns.flatMap((e) => (e.children ? e.children : [e]));
          const col = flatColumns.find((e) => (e.key || e.dataIndex) === prop);
          const dataIndex = col?.dataIndex || prop;
          if (item[dataIndex] !== null) {
            const renderedValue = col?.render?.(item[dataIndex], item) || item[dataIndex];
            const stringValue = renderedValue?.toString()?.toLowerCase()?.trim();
            const searchValue = value.toLowerCase()?.trim();
            if (renderedValue?.props?.children) {
              const valueRenderString = extractTextFromNode(renderedValue).toLowerCase().trim();
              return valueRenderString.includes(searchValue);
            }
            if (col?.filterMode === 'contains') {
              return stringValue?.includes(searchValue);
            }
            if (col?.filterMode === 'exact-first') {
              return stringValue?.startsWith(searchValue);
            }
            if (prop === 'estados_globales') {
              return stringValue?.includes(searchValue);
            }
            if (stringValue === 'no' && searchValue === 'no') {
              return true;
            }
            // return stringValue === searchValue; // search: carlos. results: "carlos"
            // return stringValue?.startsWith(searchValue); // search: carlos. results: "carlos", "carlos jose", etc
            return stringValue?.includes(searchValue); // search: carlos. results: "carlos", "carlos jose", "jose carlos", etc
          }
          return false;
        });
        const activeCol = columns.find((e) => e.key === prop);
        if (activeCol?.filterMode === 'exact-first') {
          const searchValue = value.toLowerCase().trim();
          filtered.sort((a, b) => {
            const aVal = (activeCol?.render?.(a[prop]) || a[prop])?.toString()?.toLowerCase()?.trim();
            const bVal = (activeCol?.render?.(b[prop]) || b[prop])?.toString()?.toLowerCase()?.trim();
            if (aVal === searchValue && bVal !== searchValue) return -1;
            if (bVal === searchValue && aVal !== searchValue) return 1;
            const aNum = parseFloat(aVal);
            const bNum = parseFloat(bVal);
            if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return aNum - bNum;
            return aVal?.localeCompare(bVal, 'es', { numeric: true });
          });
        }
      });
    }
    // eslint-disable-next-line no-unused-expressions
    allowExtractData && setExtractData(filtered);
    setDataSource(filtered);
    if (onTableChange) onTableChange(null, null, null, { currentDataSource: filtered });
  };

  useEffect(() => {
    if (filterNested) {
      filterNestedData();
      filterData();
    } else {
      filterData();
    }
    // eslint-disable-next-line
  }, [filters]);

  const exportMenu = {
    items: [
      allowExportExcel && {
        key: 1,
        onClick: onExportExcel || (() => handleExportExcel()),
        icon: <FileExcelOutlined />,
        label: 'Excel',
      },
      allowExportPDF && {
        key: 2,
        onClick: () => handleExportPDF(),
        icon: <FilePdfOutlined />,
        label: 'PDF',
      },
      // Opciones adicionales de la vista (p. ej. reportes), despues de Excel/PDF. A diferencia
      // de customExportMenu, conserva las opciones por defecto de la tabla.
      ...(extraExportItems || []),
    ],
  };

  const onGetTemplate = async () => {
    try {
      const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
      const resSign = await HTTP.get(`${uri}carga/sign/`);
      const { sign } = resSign.data;
      window.open(`${baseURL}${uri}carga/plantilla?sign=${sign}`, '_blank');
    } catch (err) {
      onError(err);
    }
  };

  const onGetTemplateExtra = async () => {
    try {
      const uri = baseURI.at(-1) === '/' ? baseURIExtra : `${baseURIExtra}/`;
      const resSign = await HTTP.get(`${uri}carga/sign/`);
      const { sign } = resSign.data;
      window.open(`${baseURL}${uri}carga/plantilla?sign=${sign}`, '_blank');
    } catch (err) {
      onError(err);
    }
  };

  const onGetTemplateExtraPago = async () => {
    try {
      const uri = baseURI.at(-1) === '/' ? baseURIExtraPago : `${baseURIExtraPago}/`;
      const resSign = await HTTP.get(`${uri}carga/sign/`);
      const { sign } = resSign.data;
      window.open(`${baseURL}${uri}carga/plantilla?sign=${sign}`, '_blank');
    } catch (err) {
      onError(err);
    }
  };

  const exportExcel = (dataSourceParam, columnParam, fileName) => {
    const worksheet = XLSX.utils
      .json_to_sheet(dataSourceParam.map((record) => columnParam.reduce((obj, column) => {
        const render = column?.render;
        if (render !== undefined) {
          obj[column.titleText] = render(record[column.dataIndex], record);
        } else {
          obj[column.titleText] = record[column.dataIndex];
        }
        return obj;
      }, {})));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  // 🔽 Nueva versión compatible con estructuras arboladas
  const handleExportExcel = () => {
    // eslint-disable-next-line react/prop-types
    const fileName = permission?.model ? permission?.model : 'TABLA';

    const flattenTree = (tree) => {
      const result = [];
      const traverse = (nodes) => {
        nodes.forEach((node) => {
          const { children, ...rest } = node;
          result.push(rest);
          if (children && children.length > 0) traverse(children);
        });
      };
      traverse(tree);
      return result;
    };

    if (filterNested && Array.isArray(customDataArbolado)) {
      const flatData = flattenTree(customDataArbolado);
      exportExcel(flatData, columns, fileName);
    } else {
      exportExcel(dataSource, columns, fileName);
    }
  };

  const handleExportPDF = () => {
    // eslint-disable-next-line react/prop-types
    const fileName = permission?.model ? permission?.model : 'TABLA';
    const allData = dataSource.map((record) => cols.reduce((obj, column) => {
      const render = column?.render;
      if (render !== undefined) {
        obj[column.titleText] = render(record[column.dataIndex], record);
      } else {
        obj[column.titleText] = record[column.dataIndex];
      }
      return obj;
    }, {}));

    const dataCols = cols.length > 9 ? [...cols.slice(0, 9), cols[cols.length - 1]] : cols;
    const dataFiltered = allData.map((objeto) => {
      const dataColumns = Object.keys(objeto);
      const dataColumnsSlice = dataColumns.slice(0, 9);
      const dataColumnsFiltered = dataColumns.length > 9 ? [...dataColumnsSlice, dataColumns[dataColumns.length - 1]] : dataColumnsSlice;
      const newObject = {};
      dataColumnsFiltered.forEach((col) => {
        newObject[col] = objeto[col];
      });
      return newObject;
    });
    const tableData = dataFiltered.map((element) => {
      const tableRow = {};
      dataCols.forEach((column) => {
        tableRow[column.key] = element[column.titleText];
        if (tableRow[column.key] === undefined) {
          tableRow[column.key] = '';
        }
      });
      return tableRow;
    });
    const currentDate = new Date();
    const formattedDate = format(currentDate, "eeee, dd 'de' MMMM 'de' yyyy", { locale: es });
    const entidadId = entidad.id;
    PDFTest(entidadId, dataCols, tableData, fileName, formattedDate);
  };

  const PDFTest = async (entidadId, colsFinal, dataFinal, name, date) => {
    try {
      await descargarPDFGeneral(entidadId, titleTable, colsFinal, dataFinal, date)
        .then((pdfData) => {
          const blob = new Blob([pdfData], {
            type: 'application/pdf',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${name}.pdf`;
          link.click();
        });
    } catch (err) {
      onError(
        err,
      );
    }
  };

  const importMenu = {
    items: [
      {
        key: 1,
        onClick: onGetTemplate,
        icon: <FileExcelOutlined />,
        label: 'Obtener plantilla',
      },
      {
        key: 2,
        onClick: () => setVisibleModal(true),
        icon: <DownloadOutlined />,
        label: 'Cargar',
      },
    ],
  };

  const importMenuExtra = {
    items: [
      {
        key: 1,
        onClick: onGetTemplateExtra,
        icon: <FileExcelOutlined />,
        label: 'Obtener plantilla',
      },
      {
        key: 2,
        onClick: () => setVisibleModalExtra(true),
        icon: <DownloadOutlined />,
        label: 'Cargar',
      },
    ],
  };

  const importMenuExtraPago = {
    items: [
      {
        key: 1,
        onClick: onGetTemplateExtraPago,
        icon: <FileExcelOutlined />,
        label: 'Obtener plantilla',
      },
      {
        key: 2,
        onClick: () => setVisibleModalExtraPago(true),
        icon: <DownloadOutlined />,
        label: 'Cargar',
      },
    ],
  };

  // Orígenes de importación activos, en el mismo orden que los botones sueltos.
  // Solo se usa cuando `groupImports` agrupa todo en un menú.
  const importSources = [
    allowImport && !allowCustomImport && { label: 'Importar', items: importMenu.items },
    allowCustomImport && { label: customImportText, items: customImportMenu?.props?.items },
    allowCustomImportExtra && { label: customImportExtraText, items: customImportMenuExtra?.props?.items },
    allowCustomImportExtraPago && { label: customImportExtraTextPago, items: customImportMenuExtraPago?.props?.items },
    allowExtraImport && { label: `Importar ${labelExtraImport}`, items: importMenuExtra.items },
    allowExtraImportPago && { label: `Importar ${labelExtraImportPago}`, items: importMenuExtraPago.items },
  ].filter(Boolean);

  // Para columnas agrupadas (título con `children`), el ancho real es la suma
  // de los anchos de sus hijas, no un `width` propio (que normalmente no existe
  // en el nivel del grupo, y si existe no coincide con el contenido real).
  const getColWidth = (col) => (Array.isArray(col.children)
    ? col.children.reduce((sum, child) => sum + (child.width || 0), 0)
    : col.width);

  useEffect(() => {
    const filtered = columns.filter((col) => getColWidth(col) && selectedCols.includes(col.key));
    const sum = filtered.reduce((prev, next) => prev + getColWidth(next), 0);
    setScrollX(sum);
    // eslint-disable-next-line
  }, [selectedCols]);

  const content = () => {
    const flatCols = columns.flatMap((col) => (col.children ? col.children : [col]));
    const options = flatCols.map(({ key, titleText, title }) => ({
      key,
      text: titleText || title,
    }));
    return (
      <div style={{ maxWidth: 350 }}>
        <Text>
          Seleccione las columnas que desea mostrar
        </Text>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          value={selectedCols}
          onChange={(val) => {
            if (val.length >= 1) {
              setSelectedCols(val);
            }
          }}
        >
          {options.map((o) => (
            <Option value={o.value} key={o.key}>
              {o.text}
            </Option>
          ))}
        </Select>
      </div>
    );
  };

  const hasAllViewPermission = _hasAllViewPermission
    || permission?.hasAllViewPermission || !permission;

  // Se invoca como función (`TableControls()`), no como componente (`<TableControls />`):
  // al estar definido dentro de Table, como componente React lo trataría como un tipo nuevo
  // en cada render y remontaría toda la barra, cerrando cualquier Dropdown abierto (Acciones,
  // Importar, Exportar) en vistas que se re-renderizan seguido. No usa hooks, así que es seguro.
  const TableControls = () => (
    <Row
      align="middle"
      justify="space-between"
      style={{ paddingBottom: 10, maxWidth: '100%' }}
      className="table-controls"
    >
      <div>
        {(allowColumnSelector && screens.md) && (
          <Popover
            open={open}
            placement="bottomRight"
            content={content}
            title={(
              <Row
                align="middle"
                justify="space-between"
              >
                <Text className="title">
                  Selector de columnas
                </Text>
                <Button type="link" onClick={() => setVisible(false)}>
                  <ArrowLeftOutlined />
                  Cancelar
                </Button>
              </Row>
            )}
            trigger="click"
          >
            <Button type="link" onClick={() => setVisible(true)}>
              <TableOutlined />
              Selector de columnas
            </Button>
          </Popover>
        )}
      </div>
      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        {controls?.onClickBuscar && (
          <Button type="link" onClick={controls.onClickBuscar}>
            <SearchOutlined />
            {' '}
            {screens.md && 'Buscar Empleados'}
          </Button>
        )}
        {controls?.onClickLimpiar && (
          <Button type="link" onClick={controls.onClickLimpiar}>
            <UndoOutlined />
            {' '}
            {screens.md && 'Limpiar'}
          </Button>
        )}
        {controls?.onClickAutorizar && (
          <Button type="link" onClick={controls.onClickAutorizar}>
            <CheckOutlined />
            {' '}
            {screens.md && 'Autorizar'}
          </Button>
        )}
        {controls?.onClickGuardar && (
          <Button type="link" onClick={controls.onClickGuardar}>
            <CheckOutlined />
            {' '}
            {screens.md && 'Guardar'}
          </Button>
        )}
        {controls?.onClickRenovar && (
          <Button type="link" onClick={controls.onClickRenovar}>
            <ReloadOutlined />
            {' '}
            {screens.md && 'Renovar'}
          </Button>
        )}
        {controls?.onClickValidarVigencia && (
          <Button type="link" onClick={controls.onClickValidarVigencia}>
            <ExclamationCircleOutlined />
            {' '}
            {screens.md && 'Validar Vigencia'}
          </Button>
        )}
        {controls?.onClickBaja && (
          <Button type="link" onClick={controls.onClickBaja}>
            <CloseCircleOutlined />
            {' '}
            {screens.md && 'Baja'}
          </Button>
        )}

        {allowConfig && (
          <Button
            onClick={controls.onClickConfig}
            disabled={!rowSelection.selectedRowKeys.length}
            type="link"
          >
            <SettingOutlined />
            {screens.md && 'Configurar'}
          </Button>
        )}
        {allowMultiSelect && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => onMultiSelect()}
              type="link"
            >
              <CheckSquareOutlined />
              {screens.md && 'Seleccionar Todos'}
            </Button>
          </ButtonWrapper>
        )}
        {allowMultiDeselect && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => onMultiDeselect()}
              type="link"
            >
              <CloseSquareOutlined />
              {screens.md && 'Deseleccionar Todos'}
            </Button>
          </ButtonWrapper>
        )}
        {allowMultiTrueChanger && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => controls.onClickTrue()}
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || !permission?.change}
              type="link"
            >
              <CheckSquareOutlined />
              {screens.md && multiTrueChangerText}
            </Button>
          </ButtonWrapper>
        )}
        {allowMultiFalseChanger && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => controls.onClickFalse()}
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || !permission?.change}
              type="link"
            >
              <CloseSquareOutlined />
              {screens.md && multiFalseChangerText}
            </Button>
          </ButtonWrapper>
        )}
        {allowAdd && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => controls.onClickAdd()}
              disabled={!hasAllViewPermission || !permission?.add || disableAdd}
              type="link"
            >
              <PlusOutlined />
              {screens.md && addText}
            </Button>
          </ButtonWrapper>
        )}
        {allowReload && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.add}>
            <Button
              onClick={() => controls.onClickReload()}
              disabled={!hasAllViewPermission || !permission?.add || disableAdd}
              type="link"
            >
              <ReloadOutlined />
              {screens.md && 'Actualizar'}
            </Button>
          </ButtonWrapper>
        )}
        {allowEdit && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || rowSelection?.selectedRowKeys.length > 1
                || !permission?.change || disableEdit}
              onClick={() => controls.onClickEdit()}
              type="link"
            >
              <EditOutlined />
              {screens.md && editText}
            </Button>
          </ButtonWrapper>
        )}
        {/* Botón de edición secundario opcional (p. ej. "Editar" junto a "Detalle" en
            Cálculo de Nóminas): mismo criterio de selección que el principal, más su propio
            `disableSecondaryEdit`. Solo aparece si la vista pasa controls.onClickSecondaryEdit. */}
        {!!controls?.onClickSecondaryEdit && (
          <ButtonWrapper hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || rowSelection?.selectedRowKeys.length > 1
                || !permission?.change || disableSecondaryEdit}
              onClick={() => controls.onClickSecondaryEdit()}
              type="link"
            >
              <EditOutlined />
              {screens.md && secondaryEditText}
            </Button>
          </ButtonWrapper>
        )}
        {allowDelete && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.delete} delete>
            <Button
              disabled={!rowSelection?.selectedRowKeys.length || !permission?.delete || disableDelete}
              onClick={() => {
                controls.onClickDelete();
                setTimeout(() => {
                  const submitBtnDelete = document.querySelector('.submit-delete');
                  if (submitBtnDelete) {
                    submitBtnDelete.focus();
                  }
                });
              }}
              type="link"
            >
              <DeleteOutlined />
              {screens.md && deleteText}
            </Button>
          </ButtonWrapper>
        )}
        {allowUnasign && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.delete} delete>
            <Button
              disabled={!rowSelection?.selectedRowKeys.length || !permission?.delete || disableDelete}
              onClick={() => {
                controls.onClickUnasign();
                setTimeout(() => {
                  const submitBtnUnasign = document.querySelector('.submit-unasign');
                  if (submitBtnUnasign) {
                    submitBtnUnasign.focus();
                  }
                });
              }}
              type="link"
            >
              <CloseCircleOutlined />
              {screens.md && unasignText}
            </Button>
          </ButtonWrapper>
        )}
        {allowExpand && (
          <Button
            disabled={!hasAllViewPermission || !rowSelection?.selectedRowKeys.length}
            onClick={() => controls.onClickExpand()}
            type="link"
          >
            <ExpandOutlined />
            {screens.md && 'Vista completa'}
          </Button>
        )}
        {allowReports && (
          <Dropdown
            menu={reportsMenu?.props}
            placement="top"
            style={{
              height: 32,
            }}
            // eslint-disable-next-line max-len, react/prop-types
            disabled={reportsMenu?.props?.items?.every((elem) => elem.disabled) || reportsMenu?.props?.disabled}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <FaClipboardList
                style={{
                  marginRight: '5px',
                }}
              />
              {screens.md && 'Reportes'}
            </Button>
          </Dropdown>
        )}
        {allowExport && !allowCustomExport && (
          <Dropdown
            menu={exportMenu}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <UploadOutlined />
              {screens.md && 'Exportar'}
            </Button>
          </Dropdown>
        )}
        {allowCustomExport && (
          <Dropdown
            menu={customExportMenu?.props}
            placement="top"
            style={{
              heigth: 32,
            }}
            // eslint-disable-next-line max-len, react/prop-types
            disabled={customExportMenu?.props?.items?.every((elem) => elem.disabledBySelection === false) ? false : !rowSelection.selectedRowKeys.length}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <UploadOutlined />
              {screens.md && 'Exportar'}
            </Button>
          </Dropdown>
        )}
        {groupImports && !!importSources.length && (
          // Agrupa todas las importaciones (plantilla/cargar de cada origen) en un
          // solo menú con submenús, para ahorrar espacio en la barra.
          <Dropdown
            trigger={['click']}
            menu={{
              items: importSources.map((source, index) => ({
                key: `import-${index}`,
                label: source.label,
                icon: <DownloadOutlined />,
                children: (source.items || []).map((item) => ({
                  ...item,
                  key: `import-${index}-${item.key}`,
                })),
              })),
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && groupImportsText}
              <DownOutlined />
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowImport && !allowCustomImport && (
          <Dropdown
            menu={importMenu}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && 'Importar'}
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowCustomImport && (
          <Dropdown
            menu={customImportMenu?.props}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && customImportText}
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowCustomImportExtra && (
          <Dropdown
            menu={customImportMenuExtra?.props}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && customImportExtraText}
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowCustomImportExtraPago && (
          <Dropdown
            menu={customImportMenuExtraPago?.props}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && customImportExtraTextPago}
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowExtraImport && (
          <Dropdown
            menu={importMenuExtra}
            placement="top"
            style={{
              heigth: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && `Importar ${labelExtraImport}`}
            </Button>
          </Dropdown>
        )}
        {!groupImports && allowExtraImportPago && (
          <Dropdown
            menu={importMenuExtraPago}
            placement="top"
            style={{
              height: 32,
            }}
          >
            <Button
              style={{
                padding: '4px 15px',
              }}
              type="link"
              onClick={(e) => e.preventDefault()}
            >
              <DownloadOutlined />
              {screens.md && `Importar ${labelExtraImportPago}`}
            </Button>
          </Dropdown>
        )}
        {(justImport && baseURI) && (
          <Button
            style={{
              padding: '4px 15px',
            }}
            type="link"
            onClick={() => {
              setVisibleModal(true);
            }}
          >
            <DownloadOutlined />
            {screens.md && 'Importar'}
          </Button>
        )}
        {allowSearch && (
          <Button
            onClick={() => setVisibleSearch(!visibleSarch)}
            type="link"
          >
            <SearchOutlined />
            {screens.md && 'Búsqueda'}
          </Button>
        )}
        {allowActivate && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys?.length || !permission?.change || disableActivate}
              onClick={() => controls.onClickActivate()}
              type="link"
            >
              <CheckCircleOutlined />
              {screens.md && 'Activar'}
            </Button>
          </ButtonWrapper>
        )}
        {allowDeactivate && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys?.length || !permission?.change || disableDeactivate}
              onClick={() => controls.onClickDeactivate()}
              type="link"
            >
              <MinusCircleOutlined />
              {screens.md && 'Desactivar'}
            </Button>
          </ButtonWrapper>
        )}
        {!!allowedCustomActions.length && customActionsDropdown && (
          // Agrupa las customActions en un solo menú desplegable para ahorrar
          // espacio en la barra (útil cuando hay muchas acciones por estatus).
          // Cada opción conserva su propia regla de habilitado.
          <Dropdown
            trigger={['click']}
            menu={{
              // La key va por posición (no por `text`): algunas vistas pasan un elemento
              // React como `text` (p. ej. un Tooltip), que no sirve como key ni para ubicar
              // la acción al hacer clic.
              items: allowedCustomActions.map(({ disabledBySelection = true, ...item }, index) => ({
                key: `accion-${index}`,
                label: item.text,
                icon: item.icon,
                danger: item?.className === 'cancel',
                disabled: item?.disabled
                  || (disabledBySelection ? !rowSelection?.selectedRowKeys?.length : !!item.disabled),
              })),
              onClick: ({ key }) => allowedCustomActions[Number(key.replace('accion-', ''))]?.onClick(),
            }}
          >
            <Button type="link" onClick={(e) => e.preventDefault()}>
              <SettingOutlined />
              {screens.md && customActionsDropdownText}
              <DownOutlined />
            </Button>
          </Dropdown>
        )}
        {!!allowedCustomActions.length && !customActionsDropdown && (
          allowedCustomActions.map(({ disabledBySelection = true, ...item }) => {
            const button = (
              <Button
                disabled={item?.disabled || (disabledBySelection ? !rowSelection?.selectedRowKeys?.length : !!item.disabled)}
                onClick={item.onClick}
                type="link"
                className={item?.className || ''}
                key={item.text}
              >
                {item.icon}
                {screens.md && item.text}
              </Button>
            );
            // `tooltip` opcional: explica la acción (p. ej. por qué está deshabilitada).
            // antd 4 ya muestra el Tooltip sobre botones deshabilitados, sin <span> manual.
            return item.tooltip ? (
              <Tooltip title={item.tooltip} key={item.text}>
                {button}
              </Tooltip>
            ) : button;
          })
        )}
        {allowReprint && (
          <ButtonWrapper hasAllViewPermission={hasAllViewPermission} hasSelection={!!rowSelection?.selectedRowKeys?.length} hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length
                || rowSelection?.selectedRowKeys.length > 1
                || !permission?.change}
              onClick={() => controls.onClickReprint()}
              type="link"
            >
              <PrinterOutlined />
              {screens.md && 'Reimprimir'}
            </Button>
          </ButtonWrapper>
        )}
      </div>
    </Row>
  );

  const rules = {
    required: [
      {
        required: true,
        message: 'El campo es requerido',
      },
    ],
  };

  // Polling de una carga masiva async (carga-async/) — consulta ProcesoEnCursoTerminado
  // cada 2s hasta que `procesando` sea false (o se agoten los intentos, ~11 min) y
  // reporta avance vía setProgreso. onFinish recibe el proceso final (o null si expiró).
  const pollCargaAsync = (descripcion, setProgreso, onFinish) => {
    let intentos = 0;
    const maxIntentos = 340;
    const intervalId = setInterval(async () => {
      intentos += 1;
      const lista = await getProcesoEnCursoTerminado({ descripcion });
      const proceso = lista[0];
      if (proceso) {
        setProgreso({
          enCurso: proceso.registro_en_curso || 0,
          total: proceso.total_registros || 0,
        });
      }
      const termino = proceso && proceso.procesando === false;
      if (termino || intentos >= maxIntentos) {
        clearInterval(intervalId);
        onFinish(termino ? proceso : null);
      }
    }, 2000);
    return intervalId;
  };

  const renderProgresoCarga = (progreso) => (
    <div style={{ textAlign: 'center', padding: '16px 0' }}>
      <Progress
        type="circle"
        percent={
          progreso.total > 0
            ? Math.min(Math.round((progreso.enCurso / progreso.total) * 100), 99)
            : 0
        }
        status="active"
      />
      <p style={{ marginTop: 16 }}>
        {progreso.enCurso}
        {' / '}
        {progreso.total || '?'}
        {' Registros Procesados'}
      </p>
    </div>
  );

  const handleCargaResponse = (response, cancelFn, setLoadingFn) => {
    const { message: msg, filename, file_b64: fileB64 } = response.data || {};
    if (fileB64 && filename) {
      const byteChars = atob(fileB64);
      const byteArray = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i += 1) {
        byteArray[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      notification.warning({
        message: 'La carga contiene errores. Revise el archivo descargado.',
        description: (
          <div style={{ whiteSpace: 'pre-line', maxHeight: 300, overflowY: 'auto' }}>
            {msg}
          </div>
        ),
        duration: 0,
      });
    } else {
      message.info(msg || 'Carga realizada correctamente.', 20);
    }
    cancelFn();
    setLoadingFn(false);
    if (typeof controls?.onClickReload === 'function') {
      controls.onClickReload();
    }
  };

  const ModalUpload = () => {
    const [formCarga] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [progreso, setProgreso] = useState(null);
    const pollingRef = useRef(null);

    const onCancel = () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      setVisibleModal(false);
      setProgreso(null);
      formCarga.resetFields();
    };

    useEffect(() => () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    }, []);

    const onUpload = async () => {
      try {
        await formCarga.validateFields();
        const { file } = formCarga.getFieldsValue();
        if (file) {
          setLoading(true);
          const formData = new FormData();
          formData.append('file', file.file);
          const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
          if (asyncImport) {
            const response = await HTTP.post(`${baseURL}${uri}carga-async/`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 60000,
            });
            if (response?.status === 202 && response.data?.descripcion) {
              setProgreso({ enCurso: 0, total: 0 });
              pollingRef.current = pollCargaAsync(response.data.descripcion, setProgreso, (proceso) => {
                pollingRef.current = null;
                setProgreso(null);
                if (proceso) {
                  handleCargaResponse({
                    data: {
                      message: proceso.mensaje,
                      filename: proceso.resultado ? 'carga-masiva-errores.xlsx' : null,
                      file_b64: proceso.resultado,
                    },
                  }, onCancel, setLoading);
                } else {
                  setLoading(false);
                  onCancel();
                }
              });
            } else {
              setLoading(false);
            }
          } else {
            const response = await HTTP.post(`${baseURL}${uri}carga/`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              timeout: 600000,
            });
            if (response?.status === 200) {
              handleCargaResponse(response, onCancel, setLoading);
            }
          }
        }
      } catch (err) {
        onError(err, setLoading);
      }
    };

    return (
      <Modal
        open={visibleModal}
        title={progreso ? 'Procesando Carga Masiva...' : (
          <FormSubmitControls
            label="Carga Masiva"
            onFinish={onUpload}
            onCancel={onCancel}
            loading={loading}
          />
        )}
        onCancel={onCancel}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        forceRender
        destroyOnClose
      >
        {progreso ? renderProgresoCarga(progreso) : (
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name={`carga_${componentKey}`}
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={allowedExtensions}
              />
            </Form>
          </Spin>
        )}
      </Modal>
    );
  };

  const ModalUploadExtra = () => {
    const [formCarga] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [progreso, setProgreso] = useState(null);
    const pollingRef = useRef(null);

    const onCancel = () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      setVisibleModalExtra(false);
      setProgreso(null);
      formCarga.resetFields();
    };

    useEffect(() => () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    }, []);

    const onUpload = async () => {
      try {
        await formCarga.validateFields();
        const { file } = formCarga.getFieldsValue();
        if (file) {
          setLoading(true);
          const formData = new FormData();
          formData.append('file', file.file);
          const uri = baseURI.at(-1) === '/' ? baseURIExtra : `${baseURIExtra}/`;
          if (asyncImportExtra) {
            const response = await HTTP.post(`${baseURL}${uri}carga-async/`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 60000,
            });
            if (response?.status === 202 && response.data?.descripcion) {
              setProgreso({ enCurso: 0, total: 0 });
              pollingRef.current = pollCargaAsync(response.data.descripcion, setProgreso, (proceso) => {
                pollingRef.current = null;
                setProgreso(null);
                if (proceso) {
                  handleCargaResponse({
                    data: {
                      message: proceso.mensaje,
                      filename: proceso.resultado ? 'carga-masiva-errores.xlsx' : null,
                      file_b64: proceso.resultado,
                    },
                  }, onCancel, setLoading);
                } else {
                  setLoading(false);
                  onCancel();
                }
              });
            } else {
              setLoading(false);
            }
          } else {
            const response = await HTTP.post(`${baseURL}${uri}carga/`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              timeout: 600000,
            });
            if (response?.status === 200) {
              handleCargaResponse(response, onCancel, setLoading);
            }
          }
        }
      } catch (err) {
        onError(err, setLoading);
      }
    };

    return (
      <Modal
        open={visibleModalExtra}
        title={progreso ? 'Procesando Carga Masiva...' : (
          <FormSubmitControls
            label="Carga Masiva"
            onFinish={onUpload}
            onCancel={onCancel}
            loading={loading}
          />
        )}
        onCancel={onCancel}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        forceRender
        destroyOnClose
      >
        {progreso ? renderProgresoCarga(progreso) : (
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name={`carga_${componentKey}`}
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={allowedExtensions}
              />
            </Form>
          </Spin>
        )}
      </Modal>
    );
  };

  const ModalUploadExtraPago = () => {
    const [formCarga] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [progreso, setProgreso] = useState(null);
    const pollingRef = useRef(null);

    const onCancel = () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      setVisibleModalExtraPago(false);
      setProgreso(null);
      formCarga.resetFields();
    };

    useEffect(() => () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    }, []);

    const onUpload = async () => {
      try {
        await formCarga.validateFields();
        const { file } = formCarga.getFieldsValue();
        if (file) {
          setLoading(true);
          const formData = new FormData();
          formData.append('file', file.file);
          const uri = baseURIExtraPago.at(-1) === '/' ? baseURIExtraPago : `${baseURIExtraPago}/`;
          if (asyncImportExtraPago) {
            const response = await HTTP.post(`${baseURL}${uri}carga-async/`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 60000,
            });
            if (response?.status === 202 && response.data?.descripcion) {
              setProgreso({ enCurso: 0, total: 0 });
              pollingRef.current = pollCargaAsync(response.data.descripcion, setProgreso, (proceso) => {
                pollingRef.current = null;
                setProgreso(null);
                if (proceso) {
                  handleCargaResponse({
                    data: {
                      message: proceso.mensaje,
                      filename: proceso.resultado ? 'carga-masiva-errores.xlsx' : null,
                      file_b64: proceso.resultado,
                    },
                  }, onCancel, setLoading);
                } else {
                  setLoading(false);
                  onCancel();
                }
              });
            } else {
              setLoading(false);
            }
          } else {
            const response = await HTTP.post(`${baseURL}${uri}carga/`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 600000,
            });
            if (response?.status === 200) {
              handleCargaResponse(response, onCancel, setLoading);
            }
          }
        }
      } catch (err) {
        onError(err, setLoading);
      }
    };

    return (
      <Modal
        open={visibleModalExtraPago}
        title={progreso ? 'Procesando Carga Masiva...' : (
          <FormSubmitControls
            label="Carga Masiva de Datos de Pago"
            onFinish={onUpload}
            onCancel={onCancel}
            loading={loading}
          />
        )}
        onCancel={onCancel}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        forceRender
        destroyOnClose
      >
        {progreso ? renderProgresoCarga(progreso) : (
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name={`carga_pago_${componentKey}`}
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo de Datos de Pago"
                limitMB={30}
                rules={[{ required: true, message: 'Debe subir un archivo' }]}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        )}
      </Modal>
    );
  };

  const emptyTextMessage = hasAllViewPermission
    ? 'No hay datos' : 'Hacen falta permisos en los catálogos relacionados a este módulo';

  // Ant Design centra el emptyText respecto al ancho total de scroll (scrollX), no al
  // viewport visible. En tablas con muchas columnas anchas y ventana angosta eso deja el
  // texto fuera de pantalla. Se ancla a `visibleWidth` (ancho real del contenedor, medido
  // via ResizeObserver) para que siempre se vea centrado en el área visible.
  const locale = {
    emptyText: (
      <div
        style={{
          position: 'sticky',
          insetInlineStart: 0,
          width: visibleWidth || '100%',
        }}
      >
        {emptyTextMessage}
      </div>
    ),
  };

  const _dataSource = hasAllViewPermission ? dataSource : [];

  if (screens.md || !mobileColumns || mobileColumns.length > 1 || expandable) {
    return (
      <React.Fragment key={componentKey}>
        {(!noControls && !disabled) && TableControls()}
        <div ref={setTableWrapperRef}>
        {/* fillHeight (opt-in, p. ej. Registro de Vacaciones): con filas altas por texto
            envuelto (3-4 líneas), calcPageSize redondea hacia abajo y deja casi una fila
            entera de espacio vacío bajo la paginación. Con fillHeight el cuerpo de la tabla
            siempre mide exactamente tableHeight (ver `.fill-height` en Layout/index.scss) y
            se redondea hacia arriba, así la tabla ocupa todo el alto disponible y la última
            fila parcial queda en el scroll interno de la tabla, no en el de la página. */}
        <div
          ref={tableWrapperRef}
          className={fillHeight ? 'fill-height' : undefined}
          style={fillHeight ? { '--table-body-height': `${tableHeight}px` } : undefined}
        >
          <AntTable
            size="small"
            columns={columns.filter((col) => selectedCols.includes(col.key))}
            dataSource={_dataSource}
            pagination={pagination && {
              position: ['bottomLeft'],
              pageSize: autoFit && pageSize === 10 ? autoPageSize : pageSize,
            }}
            // Vuelve a medir rowHeight (promedio de las filas visibles, ver
            // measureTableHeight) tras cambiar de página, para que pageSize se ajuste
            // al alto real de las filas de esa página sin esperar a otra remedición
            // (cambio de filtro, resize, etc.).
            onChange={() => setTimeout(measureTableHeight, 0)}
            scroll={{
              y: tableHeight,
              x: !Number.isNaN(scrollX) ? scrollX : 0,
              scrollToFirstRowOnChange: true,
            }}
            rowSelection={disabled ? null : rowSelection}
            expandable={expandable}
            onRow={disabled ? null : onRow}
            className={`custom-table ${rowSelection && !disabled ? 'selectable' : ''}`}
            rowKey={rowKey}
            loading={tableLoading}
            locale={locale}
            summary={summaryCells && _dataSource.length ? (
              (pageData) => {
                const mappedCells = summaryCells.map((cell) => {
                  const value = cell.calculateValue ? cell.calculateValue(pageData) : cell.value;
                  return (
                    <>
                      {cell.label ? (
                        <AntTable.Summary.Cell align={cell.labelAlign} colSpan={cell.labelColSpan || 1}>
                          {cell.label}
                        </AntTable.Summary.Cell>
                      ) : null}
                      <AntTable.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                        {cell.render ? cell.render(value) : value}
                      </AntTable.Summary.Cell>
                    </>
                  );
                });

                return (
                  <AntTable.Summary.Row>
                    {rowSelection && !disabled ? <AntTable.Summary.Cell /> : null}
                    {mappedCells}
                  </AntTable.Summary.Row>
                );
              }
            ) : null}
          />
        </div>
        {(!pagination && count > 1) && (
          <Pagination
            page={page}
            setPage={setPage}
            callback={paginationCallback}
            count={count}
            q={q}
            pageSize={pageSize}
          />
        )}
        {(allowImport || justImport) && <ModalUpload />}
        {allowExtraImport && <ModalUploadExtra />}
        {allowExtraImportPago && <ModalUploadExtraPago />}
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment key={componentKey}>
      {(!noControls && !disabled) && TableControls()}
      <AntTable
        size="small"
        columns={mobileColumns}
        dataSource={_dataSource}
        pagination={pagination && {
          position: ['bottomLeft'],
        }}
        scroll={{ y: tableHeight, scrollToFirstRowOnChange: true }}
        rowSelection={disabled ? null : rowSelection}
        onRow={onRow}
        expandRowByClick
        className={`custom-table expandable-responsive-table ${rowSelection && disabled ? 'selectable' : ''}`}
        expandable={{
          expandedRowRender: (record) => cols
            .filter((c) => !c.hide)
            .map((column) => (
              <Row
                key={column.dataIndex}
                justify="space-between"
              >
                <b>
                  {`${column.titleText}:`}
                </b>
                <span>
                  {column.render
                    ? column.render(record[column.dataIndex], record)
                    : record[column.dataIndex]}
                </span>
              </Row>
            )),
          expandIcon: ({ expanded, onExpand, record }) => (record && (
            expanded ? (
              <DownOutlined onClick={(e) => {
                e.stopPropagation();
                onExpand(record, e);
              }}
              />
            ) : (
              <RightOutlined onClick={(e) => {
                e.stopPropagation();
                onExpand(record, e);
              }}
              />
            )
          )),
        }}
        rowKey={rowKey}
        loading={tableLoading}
        locale={locale}
        summary={summaryCells && _dataSource.length ? (
          (pageData) => {
            const mappedCells = summaryCells.map((cell) => {
              const value = cell.calculateValue ? cell.calculateValue(pageData) : cell.value;
              return (
                <AntTable.Summary.Row>
                  <AntTable.Summary.Cell colSpan={rowSelection && !disabled ? 2 : 1} />
                  <AntTable.Summary.Cell>
                    {`${cell.label || ''} ${cell.render ? cell.render(value) : value}`}
                  </AntTable.Summary.Cell>
                </AntTable.Summary.Row>
              );
            });

            return mappedCells;
          }
        ) : null}
      />
      {(!pagination && count > 1) && (
        <Pagination
          page={page}
          setPage={setPage}
          callback={paginationCallback}
          count={count}
          pageSize={pageSize}
        />
      )}
    </React.Fragment>
  );
};

Table.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  customDataArbolado: PropTypes.arrayOf(PropTypes.object),
  mobileCols: PropTypes.arrayOf(PropTypes.object),
  rowSelection: PropTypes.shape({
    selectedRowKeys: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.arrayOf(PropTypes.string),
    ]),
    type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  titleTable: PropTypes.string,
  editText: PropTypes.string,
  secondaryEditText: PropTypes.string,
  addText: PropTypes.string,
  deleteText: PropTypes.string,
  unasignText: PropTypes.string,
  noControls: PropTypes.bool,
  controls: PropTypes.shape({
    onClickGuardar: PropTypes.func,
    onClickAutorizar: PropTypes.func,
    onClickRenovar: PropTypes.func,
    onClickValidarVigencia: PropTypes.func,
    onClickBaja: PropTypes.func,
    onClickBuscar: PropTypes.func,
    onClickLimpiar: PropTypes.func,
    onClickAdd: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickSecondaryEdit: PropTypes.func,
    onClickExpand: PropTypes.func,
    onClickDelete: PropTypes.func,
    onClickUnasign: PropTypes.func,
    onClickConfig: PropTypes.func,
    onClickActivate: PropTypes.func,
    onClickDeactivate: PropTypes.func,
    onClickTrue: PropTypes.func,
    onClickFalse: PropTypes.func,
    onClickReprint: PropTypes.func,
    onClickReload: PropTypes.func,
  }),
  onExportExcel: PropTypes.func,
  extraExportItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.node,
    icon: PropTypes.node,
    onClick: PropTypes.func,
  })),
  onRow: PropTypes.func,
  allowEdit: PropTypes.bool,
  allowAdd: PropTypes.bool,
  allowDelete: PropTypes.bool,
  allowUnasign: PropTypes.bool,
  allowSearch: PropTypes.bool,
  defaultSearchVisible: PropTypes.bool,
  allowSort: PropTypes.bool,
  allowImport: PropTypes.bool,
  allowExtraImport: PropTypes.bool,
  allowExtraImportPago: PropTypes.bool,
  baseURIExtraPago: PropTypes.string,
  asyncImport: PropTypes.bool,
  asyncImportExtra: PropTypes.bool,
  asyncImportExtraPago: PropTypes.bool,
  allowConfig: PropTypes.bool,
  allowExpand: PropTypes.bool,
  allowCustomExport: PropTypes.bool,
  allowCustomImport: PropTypes.bool,
  allowCustomImportExtra: PropTypes.bool,
  allowCustomImportExtraPago: PropTypes.bool,
  customImportText: PropTypes.string,
  customImportExtraText: PropTypes.string,
  customImportExtraTextPago: PropTypes.string,
  allowExportParam: PropTypes.bool,
  allowActivate: PropTypes.bool,
  allowDeactivate: PropTypes.bool,
  allowMultiTrueChanger: PropTypes.bool,
  allowMultiFalseChanger: PropTypes.bool,
  multiTrueChangerText: PropTypes.string,
  multiFalseChangerText: PropTypes.string,
  allowDoubleClick: PropTypes.bool,
  allowReports: PropTypes.bool,
  allowReload: PropTypes.bool,
  disableAdd: PropTypes.bool,
  disableEdit: PropTypes.bool,
  disableSecondaryEdit: PropTypes.bool,
  disableDelete: PropTypes.bool,
  disableActivate: PropTypes.bool,
  disableDeactivate: PropTypes.bool,
  allowReprint: PropTypes.bool,
  expandable: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  filterNested: PropTypes.bool,
  childrenProp: PropTypes.string,
  RTLHead: PropTypes.bool,
  rowKey: PropTypes.string,
  fillHeight: PropTypes.bool,
  autoFit: PropTypes.bool,
  customActions: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.node.isRequired,
    text: PropTypes.string.isRequired,
    disabledBySelection: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
  })),
  customActionsDropdown: PropTypes.bool,
  customActionsDropdownText: PropTypes.string,
  groupImports: PropTypes.bool,
  groupImportsText: PropTypes.string,
  customExportMenu: PropTypes.element,
  customImportMenu: PropTypes.element,
  customImportMenuExtra: PropTypes.element,
  customImportMenuExtraPago: PropTypes.element,
  reportsMenu: PropTypes.element,
  handleOnRowClick: PropTypes.func,
  mobileColIndex: PropTypes.number,
  pageSize: PropTypes.number,
  disabled: PropTypes.bool,
  allowColumnSelector: PropTypes.bool,
  baseURI: PropTypes.string,
  baseURIExtra: PropTypes.string,
  labelExtraImport: PropTypes.string,
  labelExtraImportPago: PropTypes.string,
  indentSize: PropTypes.number,
  loading: PropTypes.bool,
  justImport: PropTypes.bool,
  allowedExtensions: PropTypes.arrayOf(PropTypes.string),
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    authorize: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    sync: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
    hasAllViewPermission: PropTypes.bool.isRequired,
  }),
  hasAllViewPermission: PropTypes.bool,
  pagination: PropTypes.bool,
  paginationCallback: PropTypes.func,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  summaryCells: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    labelAlign: PropTypes.string,
    valueAlign: PropTypes.string,
    labelColSpan: PropTypes.number,
    valueColSpan: PropTypes.number,
    render: PropTypes.func,
    calculateValue: PropTypes.func,
  })),
  allowExportExcel: PropTypes.bool,
  allowExportPDF: PropTypes.bool,
  allowExtractData: PropTypes.bool,
  setExtractData: PropTypes.func,
  allowMultiSelect: PropTypes.bool,
  allowMultiDeselect: PropTypes.bool,
  onMultiSelect: PropTypes.func,
  onMultiDeselect: PropTypes.func,
  onTableChange: PropTypes.func,
  persistFilters: PropTypes.bool,
  storageId: PropTypes.string,
};

Table.defaultProps = {
  mobileCols: [],
  data: [],
  customDataArbolado: null,
  titleTable: ' ',
  editText: 'Editar',
  secondaryEditText: 'Editar',
  addText: 'Agregar',
  deleteText: 'Eliminar',
  unasignText: 'Desasignar Plaza',
  noControls: false,
  controls: null,
  rowSelection: null,
  onRow: null,
  allowEdit: true,
  allowAdd: true,
  allowDelete: true,
  allowUnasign: false,
  allowSearch: true,
  defaultSearchVisible: false,
  allowSort: true,
  allowImport: false,
  allowExtraImport: false,
  allowExtraImportPago: true,
  labelExtraImportPago: '',
  baseURIExtraPago: '',
  asyncImport: false,
  asyncImportExtra: false,
  asyncImportExtraPago: false,
  allowConfig: false,
  allowExpand: true,
  allowCustomExport: false,
  allowCustomImport: false,
  allowCustomImportExtra: false,
  allowCustomImportExtraPago: false,
  customImportText: 'Importar',
  customImportExtraText: 'Importar',
  customImportExtraTextPago: 'Importar',
  allowExportParam: true,
  allowActivate: false,
  allowDeactivate: false,
  allowMultiTrueChanger: false,
  allowMultiFalseChanger: false,
  multiTrueChangerText: '',
  multiFalseChangerText: '',
  allowDoubleClick: true,
  allowReports: false,
  allowReload: false,
  disableAdd: false,
  disableEdit: false,
  disableSecondaryEdit: false,
  disableDelete: false,
  disableActivate: false,
  disableDeactivate: false,
  allowReprint: false,
  expandable: null,
  filterNested: false,
  childrenProp: null,
  RTLHead: false,
  rowKey: 'id',
  fillHeight: false,
  autoFit: true,
  customActions: [],
  customActionsDropdown: false,
  customActionsDropdownText: 'Acciones',
  groupImports: false,
  groupImportsText: 'Importar',
  customExportMenu: null,
  customImportMenu: null,
  customImportMenuExtra: null,
  customImportMenuExtraPago: null,
  reportsMenu: null,
  handleOnRowClick: null,
  mobileColIndex: 1,
  pageSize: 10,
  disabled: false,
  allowColumnSelector: true,
  baseURI: null,
  baseURIExtra: null,
  labelExtraImport: '',
  indentSize: 25,
  loading: false,
  justImport: false,
  allowedExtensions: ['xlsx'],
  permission: null,
  hasAllViewPermission: false,
  pagination: true,
  paginationCallback: null,
  count: 0,
  currentPage: 1,
  summaryCells: null,
  allowExportExcel: true,
  allowExportPDF: true,
  allowExtractData: false,
  setExtractData: null,
  allowMultiSelect: false,
  allowMultiDeselect: false,
  onMultiSelect: null,
  onMultiDeselect: null,
  onExportExcel: null,
  extraExportItems: [],
  onTableChange: null,
  persistFilters: true,
  storageId: null,
};

export default Table;
